module.exports = __webpack_public_path__ + "static/media/products0_190429.3105d076.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/department-module/unused/products0_190429.jpg
// module id = 724
// module chunks = 0